import { createContext, useReducer } from "react";
import axios from "axios";
import { API_URL_SUBCAT_HIERARCY } from "../../utils/apiURL";

export const subcatHierarcyContext = createContext();

const INTIAL_STATE = {
  subcategory: null,
  subcategoryHierarcy: [],
  error: null,
  loading: false,
  token: null,
  subcatSingleRow: [],
  rowdelsubCat: null,
};

const subcatHierarcyReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case "Fetch_success":
      return {
        ...state,
        loading: false,
        subcategoryHierarcy: payload,
      };
    case "Fetch_fail":
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case "Add_success":
      return {
        ...state,
        loading: false,
        subcategory: payload,
      };
    case "Add_fail":
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case "Delete_success":
      return {
        ...state,
        loading: false,
        rowdelsubCat: payload,
      };
    case "Delete_fail":
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case "Single_success":
      return {
        ...state,
        loading: false,
        subcatSingleRow: payload,
      };
    case "Single_fail":
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
};

export const SubcatHierarcyContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(subcatHierarcyReducer, INTIAL_STATE);

  // GetAllAssortment API
  const fetchSUBCategoryHierarcyAction = async (tokenVal) => {
    try {
      //header
      const config = {
        headers: {
          Authorization: `Bearer ${tokenVal}`,
          "Content-Type": "application/json;charset=utf-8",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache",
        },
      };

      const res = await axios.get(
        `${API_URL_SUBCAT_HIERARCY}/GetAllSubCategories`, config
      );

      if (res?.request.status === 200) {
        dispatch({
          type: "Fetch_success",
          payload: res?.data,
        });
      }
    } catch (error) {
      dispatch({
        type: "Fetch_fail",
        payload: error,
      });
    }
  };

  // AddUpdateAssortment API
  const addUpdateSUBCategoryHierarcyAction = async (assortmentData, tokenVal, history) => {
    try {
      //header
      const config = {
        headers: {
          Authorization: `Bearer ${tokenVal}`,
          "Content-Type": "application/json;charset=utf-8",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache",
        },
      };

      //request
      const res = await axios.post(
        `${API_URL_SUBCAT_HIERARCY}/AddUpdateSubCategory`,
        assortmentData,
        config
      );

      //dispatch
      if (res?.request.status === 200) {
        dispatch({
          type: "Add_success",
          payload: res?.data,
        });
      }
      alert(res?.data);
      history.push("/sub-category")

    } catch (error) {
      dispatch({
        type: "Add_fail",
        payload: error,
      });
      alert(error.message);
    }
  };

  // DeleteAssortment API
  const deleteSUBCategoryHierarcyAction = async (id, tokenVal) => {
    try {
      //header
      const config = {
        headers: {
          Authorization: `Bearer ${tokenVal}`,
          "Content-Type": "application/json;charset=utf-8",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache",
        },
      };

      const res = await axios.get(
        `${API_URL_SUBCAT_HIERARCY}/DeleteSubCategory?Id=${id}`, config
      );

      if (res?.request.status === 200) {
        dispatch({
          type: "Delete_success",
          payload: res?.data,
        });
      }
      alert(res?.data);
      fetchSUBCategoryHierarcyAction(tokenVal);
      // window.location.href = "/sub-category";
    } catch (error) {
      dispatch({
        type: "Delete_fail",
        payload: error,
      });
    }
  };

  // GetAssortmentById API
  const getSingleSUBCategoryHierarcyAction = async (id, tokenVal) => {
    try {
      //header
      const config = {
        headers: {
          Authorization: `Bearer ${tokenVal}`,
          "Content-Type": "application/json;charset=utf-8",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache",
        },
      };

      const res = await axios.get(
        `${API_URL_SUBCAT_HIERARCY}/GetSubCategoryById?Id=${id}`, config
      );

      if (res?.request.status === 200) {
        dispatch({
          type: "Single_success",
          payload: res?.data,
        });
      }
    } catch (error) {
      dispatch({
        type: "Single_fail",
        payload: error,
      });
    }
  };

  return (
    <subcatHierarcyContext.Provider
      value={{
        subcategory: state?.subcategory,
        subcategoryHierarcy: state?.subcategoryHierarcy,
        error: state?.error,
        loading: state?.loading,
        fetchSUBCategoryHierarcyAction,
        addUpdateSUBCategoryHierarcyAction,
        deleteSUBCategoryHierarcyAction,
        getSingleSUBCategoryHierarcyAction,
        subcatSingleRow: state?.subcatSingleRow,
        rowdelsubCat: state?.rowdelsubCat,
      }}
    >
      {children}
    </subcatHierarcyContext.Provider>
  );
};
